import initialState from "./initialState";

export const types = {
  reset: "reset",
  SET_ACCOUNT_ID: "SET_ACCOUNT_ID",
  SET_USER_DATA: "SET_USER_DATA",
  SET_ALL_USERS: "SET_ALL_USERS",
  SET_SUMMARY: "SET_SUMMARY",
};

export default {
  [types.reset]: state => {
    Object.keys(initialState()).forEach(key => {
      state[key] = initialState()[key];
    });
  },
  [types.SET_ACCOUNT_ID]: (state, accountId) => {
    state.accountId = accountId;
  },
  [types.SET_USER_DATA]: (state, data) => {
    state.userName = data.name;
    state.userEmail = data.email;
  },
};
